import { QueryKeys } from './service.js';
import WebRequest from './client/WebRequest.js';
export var GetTwilioToken;
(function (GetTwilioToken) {
    function api() {
        return WebRequest.GET('/twilio/token');
    }
    function query(client) {
        return {
            queryFn: () => client.execute(api()),
            queryKey: [QueryKeys.TWILIO_TOKEN],
            staleTime: 15 * 60 * 1000,
        };
    }
    GetTwilioToken.query = query;
})(GetTwilioToken || (GetTwilioToken = {}));
